<script setup lang="ts">
defineProps<{
  modalId: string
  title: string
  shown: boolean
  active: boolean
  deleteButtonId: string
  deleteHidden: boolean
  saveButtonId: string
  saving: boolean
  cancelButtonClass: string
}>()

const emit = defineEmits<{
  close: []
  delete: []
  save: []
}>()
</script>

<template>
  <div
    class="modal fade"
    :id="modalId"
    :class="{ show: shown }"
    :style="{ display: active ? 'block' : 'none' }"
    role="dialog"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button type="button" class="modal-close" aria-label="Close" @click="emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger modal-btn-right"
            :id="deleteButtonId"
            :class="{ hidden: deleteHidden }"
            :disabled="saving"
            @click="emit('delete')"
          >
            Delete
          </button>
          <button type="button" :class="cancelButtonClass" :disabled="saving" @click="emit('close')">Cancel</button>
          <button
            type="button"
            class="btn btn-success"
            :id="saveButtonId"
            :disabled="saving"
            @click="emit('save')"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
